module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter1"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block4"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TOC"
    }
  }, [_vm._v("Chapter 1: What We Lost")])])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph-rw",
    attrs: {
      "id": "epigraph3"
    }
  }, [_c('p', {
    staticClass: "ep1-rw",
    attrs: {
      "id": "p40"
    }
  }, [_vm._v("It is the finding of this court that Stacy Mason is innocent. She did not murder her son. She acted in self-defense, and for the good of the community, and we are sorry for her loss.")]), _vm._v(" "), _c('p', {
    staticClass: "source-rw",
    attrs: {
      "id": "source2"
    }
  }, [_vm._v("—Judge Vernon, California Supreme Court, January 9, 2018")]), _vm._v(" "), _c('p', {
    staticClass: "ep-rw",
    attrs: {
      "id": "p41"
    }
  }, [_vm._v("Oggie?")]), _vm._v(" "), _c('p', {
    staticClass: "source-rw",
    attrs: {
      "id": "source3"
    }
  }, [_vm._v("—Phillip Mason")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a629813","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s006-Chapter-001.vue
// module id = 75
// module chunks = 0